import { render, staticRenderFns } from "./UpdatePermission.vue?vue&type=template&id=0b609f11"
import script from "./UpdatePermission.vue?vue&type=script&lang=js"
export * from "./UpdatePermission.vue?vue&type=script&lang=js"
import style0 from "./UpdatePermission.vue?vue&type=style&index=0&id=0b609f11&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports